<div class="custom-input-container" role="group" [attr.aria-label]="title">
  <label class="title">{{title}}</label>
  <ng-content></ng-content>
</div>
